<script setup lang="ts">
import { computed, watch } from 'vue'
import Message from 'primevue/message';

const props = defineProps<{
  messages: string[]
  hasError?: boolean
}>()

const emits = defineEmits<{
  (e: 'remove', index: number): void
}>()

watch(
  () => props.messages,
  (newVal, oldVal) => {
    if (newVal && oldVal && newVal.length > oldVal.length) {
      setTimeout(() => {
        if (props.messages.length !== 0) emits('remove', props.messages.length - 1)
      }, 4000)
    }
  },
  { deep: true },
)
</script>

<template>
  <div class="fixed bottom-8 left-0 right-0 z-[9999] flex justify-center md:justify-end md:items-end md:left-auto md:right-8 pointer-events-none">
    <TransitionGroup tag="div" class="flex flex-col items-center md:items-end w-full md:w-auto" name="fade">
      <div v-for="(message, index) in messages" :key="index" class="mt-2 pointer-events-auto items-center px-4 text-sm w-full md:w-[40rem]">
        <div class="flex w-full cursor-pointer" @click="emits('remove', index)">
          <Message v-if="!props.hasError" icon="pi pi-check" closable size="large" :life="4000" severity="success" class="w-full justify-start text-left">{{ message }} </Message>
          <Message v-else closable icon="pi pi-times-circle" size="large" :life="4000" severity="error" class="w-full justify-start text-left">{{ message }} </Message>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}

.fade-move {
  transition: transform 0.3s ease;
}
</style>
